module.exports = __webpack_public_path__ + "static/media/header-image-desktop.c51e28e9.jpg";